import { baseADM } from '@services/env-variables';
import {
  ADD_CNPB_AND_PLAN_NAME,
  DADOS_PESSOAIS_SUCCESS,
  FORMULARIO_ENVIADO,
  FORMULARIO_RESET,
  GERAR_PROTOCOLO_SUCCESS,
  OBTER_PAGINAS_DISPONIVEIS_EXTRATO_SUCCESS,
  REQUEST_ERROR,
  UPDATE_DRAFT,
  USER_AUTH_SUCCESS,
  USER_DATA_SUCCESS,
  USER_LOGOUT_SUCCESS,
  RESET_USER,
  OBTER_PENDENCIAS_USUARIO_SUCCESS,
} from './constants';

const initialState = {
  id: '',
  matricula: '',
  token: '',
  logado: false,
  credenciaisInvalidas: false,
  plano: '',
  listaPlanos: [],
  patrocinadora: '',
  perfil: { label: '', value: '' },
  status: '',
  nome: '',
  erro: false,
  formularioEnviado: null,
  protocolo: '',
  formularioLista: [],
  dadosPessoais: {
    id: '',
    nome: '',
    nascimento: '',
    nacionalidade: '',
    genero: '',
    estadoCivil: '',
    pai: '',
    mae: '',
    cpf: '',
    rg: '',
    pis: '',
    maiorIdade: false,
    dataAdmissao: '',
    orgaoEmissorRg: '',
    dataExpedicaoRg: '',
    ufExpedicaoRg: '',
    profissao: '',
    exposta: '',
    salario: '',
    email: '',
    celular: '',
    telefone: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    cep: '',
    estado: '',
    conta: '',
    digitoConta: '',
    agencia: '',
    codBanco: '',
  },
  dadosSAPNaoTratados: {
    matricula: '',
    nome: '',
    matriculaFalecido: '',
    dependente: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    telefoneFixo: '',
    celular: '',
    email: '',
    dtNascimento: '',
    sexo: '',
    mae: '',
    pai: '',
    conjuge: '',
    cpf: '',
    rg: '',
    orgEmissor: '',
    uf: '',
    dtEmissao: '',
    localNascimento: '',
    estadoNasc: '',
    pais: '',
    nacionalidade: '',
    estadoCivil: '',
    numBanco: '',
    agencia: '',
    conta: '',
    status: '',
    dtAdminissao: '',
    dtDesligamento: '',
    motivoDeslig: '',
    dtAfastamento: '',
    motivoEncerramento: '',
    tpBeneficio: '',
    dtEncerramentoBeneficio: '',
    motivoAfastamento: '',
    planoPrevidencia: [],
    situacaoParticipante: '',
  },
  extrato: {
    plano: '',
    cnpb: '',
    habilitar: {
      SimuladorBeneficio: false,
      InformeRendimentos: false,
      ExtratoSaldoContas: false,
      Beneficiarios: false,
      ExaurimentoBeneficio: false,
      Contribuicoes: false,
      CertificadoAdesao: false,
    },
  },
  pendencias: {
    primeiroAcesso: 0,
    resetSenha: 0,
    assinaturaDoc: 0,
  },
};

// eslint-disable-next-line default-param-last
export default function user(state = initialState, action) {
  switch (action.type) {
    case USER_AUTH_SUCCESS:
      if (action.values.autenticado === true) {
        const ambienteURL = baseADM;
        const matriculaLogada =
          window.location.origin.indexOf(ambienteURL) > -1
            ? action.values.matricula
            : localStorage.getItem('Id') || action.values.matricula;

        localStorage.setItem('Id', matriculaLogada);
        localStorage.setItem('Matricula', action.values.matricula);
        localStorage.setItem('Token', action.values.token);
        localStorage.setItem('Plano', action.values.plano);
        localStorage.setItem('nivelsessao', action.values.nivelsessao);

        return {
          ...state,
          id: matriculaLogada,
          matricula: action.values.matricula,
          token: action.values.token,
          nivelsessao: action.values.nivelsessao,
          logado: true,
          patrocinadora: action.values.patrocinadora,
          plano: action.values.plano,
          listaPlanos: action.values.listaPlanos,
          perfil: action.values.perfil,
          status: action.values.status,
          nome: action.values.nomeParticipante,
          corteExtrato: action.values.corteExtrato,
          corteContracheque: action.values.corteContracheque,
          DIB: action.values.DIB,
        };
      }
      if (action.values.autenticado === false) {
        return {
          ...state,
          id: '',
          matricula: '',
          token: '',
          logado: false,
          plano: '',
          credenciaisInvalidas: true,
        };
      }
      return state;

    case USER_LOGOUT_SUCCESS:
      return {
        ...initialState,
      };

    case REQUEST_ERROR:
      return {
        ...state,
        erro: action.values,
      };

    case USER_DATA_SUCCESS:
      localStorage.setItem('Plano', action.values.plano);
      return {
        ...state,
        id: localStorage.getItem('Id'),
        matricula: action.values.matricula,
        token: action.values.token,
        logado: true,
        patrocinadora: action.values.patrocinadora,
        plano: action.values.plano,
        listaPlanos: action.values.listaPlanos,
        perfil: action.values.perfil,
        status: action.values.status,
        nome: action.values.nome,
        corteExtrato: action.values.corteExtrato,
        corteContracheque: action.values.corteContracheque,
      };

    case DADOS_PESSOAIS_SUCCESS:
      return {
        ...state,
        dadosPessoais: action.dadosPessoais.dadosPessoaisFormatados,
        dadosSAPNaoTratados: action.dadosPessoais.dadosPessoaisNaoFormatados,
      };

    case FORMULARIO_ENVIADO:
      return {
        ...state,
        formularioEnviado: action.formulario,
      };

    case FORMULARIO_RESET:
      return {
        ...state,
        formularioEnviado: null,
      };

    case GERAR_PROTOCOLO_SUCCESS:
      return {
        ...state,
        protocolo: action.protocolo,
      };

    case UPDATE_DRAFT:
      return {
        ...state,
        formularioLista: action.lista,
      };

    case ADD_CNPB_AND_PLAN_NAME:
      return {
        ...state,
        extrato: {
          ...state.extrato,
          plano: action.plano,
          cnpb: action.cnpb,
        },
      };

    case OBTER_PAGINAS_DISPONIVEIS_EXTRATO_SUCCESS: {
      const newState = (action.payload || []).reduce((prev, curr) => {
        if (initialState.extrato.habilitar[curr.Identificador] !== undefined) {
          return {
            ...prev,
            [curr.Identificador]: curr.Visibilidade,
          };
        }

        return prev;
      }, initialState.extrato.habilitar);

      return {
        ...state,
        extrato: {
          ...state.extrato,
          habilitar: newState,
        },
      };
    }

    case OBTER_PENDENCIAS_USUARIO_SUCCESS: {
      return {
        ...state,
        pendencias: {
          TermoConsentimento: action.values.TermoConsentimento,
          AtualizacaoCadastral: action.values.AtualizacaoCadastral,
        },
      };
    }

    case RESET_USER: {
      return initialState;
    }

    default:
      return state;
  }
}
